import { DueDateType } from '../../../../../db/types';
import { usePollContext } from '../../../Context';

const useLeftPart = () => {
  const { poll } = usePollContext();

  const isPollManual = poll?.preferences.dueDateType === DueDateType.MANUAL;

  return { isPollManual };
};

export default useLeftPart;
